import web3NoAccount from "./web3";
import BusdAbi from "./busdAbi.json";
import TomiAbi from "./tomiAbi.json";
import UsdcAbi from "./usdcAbi.json";
import WbtcAbi from "./wbtcAbi.json";
import TaskMnagerAbi from './tasktManagerAbi.json'
// import gemsTokenContract from "./gemsTokenAbi.json";
import LinkAbi from "./linkAbi.json"
import UiswapeAbi from "./uniswapeAbi.json"
import PepeAbi from "./pepeAbi.json"
import DopAbi from "./dopAbi.json"
import fetchDisputeTimerABI from "./fetchDisputeTimerABI.json";
import fetchMiniDisputeTimerABI from "./fetchMiniDisputeTimerABI.json";

const getContract = (abi, address, web3) => {
  const _web3 = web3;
  // // console.log('_web3',_web3);
  return new _web3.eth.Contract(abi, address);
};
export const taskManagerContract = (address, web3) => {
  return getContract(TaskMnagerAbi, address, web3);
};

export const usdtContract = (address, web3) => {
  return getContract(BusdAbi, address, web3);
};
export const tomiContract = (address, web3) => {
  return getContract(TomiAbi, address, web3);
};
export const usdcContract = (address, web3) => {
  return getContract(UsdcAbi, address, web3);
};
export const wdtcContract = (address, web3) => {
  return getContract(WbtcAbi, address, web3);
};

// export const getGemsTokenContract = (address, web3) => {
//   return getContract(gemsTokenContract, address, web3);
// };
export const linkContract = (address, web3) => {
  return getContract(LinkAbi, address, web3);
};
export const pepeContract = (address, web3) => {
  return getContract(PepeAbi, address, web3);
};
export const uniswapeContract = (address, web3) => {
  return getContract(UiswapeAbi, address, web3);
};
export const dopContract = (address, web3) => {
  return getContract(DopAbi, address, web3);
};

export const fetchDisputeTimerContract = (address, web3) => {
  return getContract(fetchDisputeTimerABI, address, web3);
};

export const fetchMiniDisputeTimerContract = (address, web3) => {
  return getContract(fetchMiniDisputeTimerABI, address, web3);
};